export default __webpack_public_path__ + "static/media/svg-6.ac875d81.svg";